module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/queen.76a8628.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/queen.jpg
// module id = dA7p
// module chunks = 0